import { ReactNode } from "react";
import { TabSwitcherProvider, Tab, TabPanel } from ".";
import classes from "./TabSwitcher.module.scss";

interface TabSwitcherProps {
  initialActiveTabId: string;
  className?: string;
  children?: ReactNode;
}

export function TabSwitcher({
  initialActiveTabId,
  children,
  className,
}: TabSwitcherProps) {
  return (
    <TabSwitcherProvider initialActiveTabId={initialActiveTabId}>
      <div className={`${classes["tab-switcher"]} ${className}`}>
        {children}
      </div>
    </TabSwitcherProvider>
  );
}

TabSwitcher.defaultProps = {
  className: "",
  children: null,
};

TabSwitcher.Tab = Tab;
TabSwitcher.Panel = TabPanel;
